const convertToTitleCase = (inputString) => {
  const splitStringArray = inputString.toLowerCase().split(" ");
  for (let i = 0; i < splitStringArray.length; i++) {
    splitStringArray[i] =
      splitStringArray[i].charAt(0).toUpperCase() +
      splitStringArray[i].substring(1);
  }
  return splitStringArray.join(" ");
};

export default convertToTitleCase;
